export const getSlicedPathName = (originalPathName: string): string => {
  const isProdBuild = process.env.NODE_ENV === 'production';
  return originalPathName.slice(originalPathName.indexOf('/', +isProdBuild));
};
